module.exports = __webpack_public_path__ + "static/media/16_2.5abc367f.jpg";